import logo from '../assets/images/logo.png';
import WhatsAppIcon from './WhatsAppIcon';
import InstagramIcon from './InstagramIcon';

const WA_URL =
  "https://wa.me/5511986304696?text=Ol%C3%A1!%20Vim%20pelo%20site%20da%20l'ora%20e%20gostaria%20de%20uma%20proposta.";

export default function Navbar() {
  return (
    <header className="wrap">
      <nav>
        <a href="#inicio" aria-label="l’ora - início">
          <span className="logo">
            <img src={logo} alt="l’ora" />
          </span>
        </a>
        <div className="navlinks">
          <a href="#servicos">Serviços</a>
          <a href="#fotografia">Fotografia</a>
          <a href="#sobre">Sobre a l’ora</a>
          <a href="#duvidas">Dúvidas</a>
          <a
            className="instagram-link"
            href="https://www.instagram.com/lora.co_/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon />
            <span>@lora.co_</span>
          </a>
          <a className="btn" href={WA_URL} target="_blank" rel="noopener noreferrer">
            <WhatsAppIcon />
            <span>
              Vamos conversar<span className="arrow" aria-hidden="true">→</span>
            </span>
          </a>
        </div>
      </nav>
    </header>
  );
}
